<script>
/**
 * Вернуть класс, применяемый для цвета фона кнопки.
 *
 * @param {String} value
 * @return {String}
 */
const getBgClass = value => {
  const bgClasses = {
    "primary": "cams-button_primary",
    "secondary": "cams-button_secondary",
  };
  return _.get(bgClasses, value, "cams-button_secondary");
};
/**
 * Вернуть класс, применяемый для размера кнопки.
 *
 * @param {String} value
 * @return {String}
 */
const getSizeClass = value => {
  const sizeClasses = {
    "l": "cams-button_large",
    "m": "cams-button_medium",
    "s": "cams-button_small",
  };
  return _.get(sizeClasses, value, "cams-button_medium");
};
/**
 * Вернуть класс, применяемый для отображения кнопки с иконкой.
 * Если использование иконки внутри кнопки не предполагается,
 * то по умолчанию будет передан класс `cams-button_icon-none`.
 *
 * По сути использование данного класса обусловлено
 * для корректной демонстрации работы компонента.
 *
 * @param {String} value
 * @return {String}
 */
const getIconClass = value => {
  const iconClasses = {
    "only": "cams-button_icon-only",
    "float": "cams-button_icon-float",
    "fixed": "cams-button_icon-fixed",
  };
  return _.get(iconClasses, value, "cams-button_icon-none");
};
/**
 * Вернуть класс, применяемый для размещения кнопки внутри смарт-инпута.
 *
 * @param {String} value
 * @return {String}
 */
const getPosClass = value => {
  const posClasses = {
    "l": "cams-button_sticky cams-button_sticky-left",
    "r": "cams-button_sticky cams-button_sticky-right",
  };
  return _.get(posClasses, value, "");
};

/**
 * Компонент кнопки.
 * В кнопку можно передавать любые html атрибуты (title, disabled, id, data...) обычным способом - они все установятся на кнопку.
 * Стили и классы передаются так же обычным способом (атрибуты class, style) и позволяют перекрывать установленные в компоненте.
 * Через v-on="listeners" прослушиваем все возможные события при взаимодействии с компонентом.
 * Через слот обычно передается текст кнопки, а также можно передать любой html.
 */
export default {
  functional: true,
  props: {
    /**
     * Вариант цвета кнопки.
     *
     * @values primary, secondary.
     */
    priority: {
      type: String,
      default: "secondary",
    },
    /**
     * Вариант размера кнопки.
     *
     * @values s, m, l.
     */
    size: {
      type: String,
      default: "m",
    },
    /**
     * Вариант отображения кнопки с иконкой.
     *
     * @values only, float, fixed.
     */
    iconType: {
      type: String,
      default: null,
    },
    /**
     * Вариант для размещения кнопки внутри смарт-инпута слева/справа от его внутреннего элемента.
     *
     * @values l, r.
     */
    position: {
      type: String,
      default: null,
    },
  },
  render(h, {data, props, listeners, slots}) {
    return h(
      "button",
      {
        class: [
          "cams-button",
          getBgClass(props.priority),
          getSizeClass(props.size),
          getIconClass(props.iconType),
          getPosClass(props.position),
          data.staticClass,
          data.class,
        ],
        style: data.staticStyle,
        attrs: data.attrs,
        ref: data.ref,
        on: listeners,
        directives: data.directives,
      },
      slots().default
    );
  }
};
</script>

<style lang="scss">
@use "./style.scss";
</style>
